/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React from 'react';
import LegacyComponent from 'components/legacy/LegacyComponent';

function getToolBarContributions(dashboardApi) {
	const collectionId = 'com.ibm.bi.explore.toolbar';

	return dashboardApi.findGlassCollection(collectionId)
		.then(collection => collection || []);
}

function requireItem(item) {
	const { view } = item;

	return new Promise((resolve, reject) => {
		// Use require on window to satisfy webpack. Webpack needs to know the full tree of dependencies
		// at build time. In this case, we don't know the module path that contributers will provide through
		// their toolbar contributions so we can't 'externalize' these in webpack so that they can be ignored.
		//
		// To get around this, use window.require so that webpack sees we're just accessing some global and
		// thinks everything is fine and dandy.
		window.require([view], resolve, reject);
	});
}

function createItem(item, context, requireItemFn) {
	return requireItemFn(item)
		.then(View => {
			if (isReactComponent(View)) {
				return <View />;
			} else {
				const view = new View(context);

				return (
					<LegacyComponent
						className="explore-vis-toolbar__item__container"
						item={view}
					/>
				);
			}
		});
}

/**
 * Get toolbar items
 *
 * @param {DashboardAPI} dashboardApi - dashboard API
 * @param {any} context - context passed into the created toolbar item views
 * @param {Function} [requireItemFn=requireItem] - require item factory method called on each one of the toolbar items before creation; defaults to the default implementation of requireItem
 *
 * @return {Promise} resolved on success and rejected on failure
 */
function getToolBarItems(dashboardApi, context, requireItemFn = requireItem) {
	return getToolBarContributions(dashboardApi)
		.then(collection => Promise
			.all(
				collection.map(item => {
					return createItem(item, context, requireItemFn)
						.then((component) => ({
							component,
							data: item
						}));
				})
			)
		);
}

// Helpers to determine if a component is a React component.

function isReactComponent(component) {
	return typeof component === 'function' && !!component.prototype.isReactComponent;
}

export {
	getToolBarItems
};



// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/ExploreToolbarExtensions.js